import triggerIds from './trigger-ids';

export default {
  triggerIds,
};
